import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Rollbar from 'utils/rollbar'
import { getUserManager } from './factsetOidc'
import { OIDC_CALLBACK_ERROR_KEY } from 'constants/sessionStorage'
import { resetAuthAttempt } from 'utils/auth'

/**
 * OIDC redirect callback — completes the PingFederate sign-in flow.
 *
 * The browser lands here after the FactSet auth server redirects back with an authorization code.
 * signinRedirectCallback exchanges that code for tokens (PKCE) and stores the user in localStorage.
 * signinRedirect (used in useAuth) initiates the flow — these two always come in pairs.
 * @returns {null} Renders nothing.
 */
export default function FactsetAuthCallback() {
  const history = useHistory()

  useEffect(() => {
    getUserManager()
      .signinRedirectCallback()
      .then(user => {
        resetAuthAttempt()
        const returnTo = user?.state?.returnTo || '/'
        history.replace(returnTo)
      })
      .catch(error => {
        Rollbar.error(error)
        // Signal useAuth to break the signinRedirect loop — without this flag,
        // a callback failure (e.g. CORS on the staging token endpoint) causes useAuth
        // to immediately call signinRedirect() again, producing ERR_TOO_MANY_REDIRECTS.
        sessionStorage.setItem(OIDC_CALLBACK_ERROR_KEY, 'true')
        history.replace('/')
      })
  }, [history])

  return null
}
